import styled from "styled-components";
import { Box } from "@chakra-ui/react";

export const SubHeaderContainer = styled(Box)`
  @media print {
    & {
      margin: 0 !important;
    }

    & > div + div {
      margin: 0 !important;
    }
  }
`;
